import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot
} from '@angular/router';
import { CareConneRoomItem } from '@app/models/user.model';
import { ApiService } from '@app/services/api.service';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Store } from '@ngxs/store';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CareconneRoomResolver implements Resolve<CareConneRoomItem[]> {
  constructor(
    private apiService: ApiService,
    private store: Store
  ) { }
  resolve(route: ActivatedRouteSnapshot): Observable<CareConneRoomItem[]> {
    let pass = this.store.selectSnapshot(SettingSelectors.CareConnePass);
    let daicd = route.queryParamMap.get('daicd') || '';
    return this.apiService.getCareConneRoomList(pass, daicd).pipe(
      switchMap((res: CareConneRoomItem[]) => {
        if (!res) {
          return of([])
        }
        return of(res)
      })
    );
  }
}
